const SUPPORT_CONFIG = {
  providerName:
    process.env.REACT_APP_SUPPORT_PROVIDER_NAME ||
    (typeof window !== 'undefined' ? window.SUPPORT_PROVIDER_NAME : '') ||
    'InfinitePay',
  message:
    process.env.REACT_APP_SUPPORT_MESSAGE ||
    (typeof window !== 'undefined' ? window.SUPPORT_MESSAGE : '') ||
    'Se o Monitor Fiscal te ajuda no dia a dia, você pode apoiar a manutenção do projeto com uma contribuição única.',
  pixKey:
    process.env.REACT_APP_SUPPORT_PIX_KEY ||
    (typeof window !== 'undefined' ? window.SUPPORT_PIX_KEY : '') ||
    '22a39261-9285-4a27-bf88-e933ccea1e91',
  pixLabel:
    process.env.REACT_APP_SUPPORT_PIX_LABEL ||
    (typeof window !== 'undefined' ? window.SUPPORT_PIX_LABEL : '') ||
    'Chave Pix via InfinitePay',
  pixMerchantName:
    process.env.REACT_APP_SUPPORT_PIX_MERCHANT_NAME ||
    (typeof window !== 'undefined' ? window.SUPPORT_PIX_MERCHANT_NAME : '') ||
    'MATEUS EMTH',
  pixMerchantCity:
    process.env.REACT_APP_SUPPORT_PIX_MERCHANT_CITY ||
    (typeof window !== 'undefined' ? window.SUPPORT_PIX_MERCHANT_CITY : '') ||
    'SAO PAULO',
  genericPaymentLink:
    process.env.REACT_APP_SUPPORT_PAYMENT_LINK ||
    (typeof window !== 'undefined' ? window.SUPPORT_PAYMENT_LINK : '') ||
    '',
  amounts: [
    {
      label: 'R$ 10',
      value: 10,
      link:
        process.env.REACT_APP_SUPPORT_LINK_10 ||
        (typeof window !== 'undefined' ? window.SUPPORT_LINK_10 : '') ||
        'https://link.infinitepay.io/mateusemth/VC1BLTEtSQ-2Ptq8eHdz-10,00'
    },
    {
      label: 'R$ 20',
      value: 20,
      link:
        process.env.REACT_APP_SUPPORT_LINK_20 ||
        (typeof window !== 'undefined' ? window.SUPPORT_LINK_20 : '') ||
        'https://link.infinitepay.io/mateusemth/VC1DLTEtSQ-7nY9TnYTxr-20,00'
    },
    {
      label: 'R$ 50',
      value: 50,
      link:
        process.env.REACT_APP_SUPPORT_LINK_50 ||
        (typeof window !== 'undefined' ? window.SUPPORT_LINK_50 : '') ||
        'https://link.infinitepay.io/mateusemth/VC1DLTEtSQ-1Iah0vI5Kr-50,00'
    }
  ]
};

const isSupportConfigured = Boolean(
  SUPPORT_CONFIG.pixKey ||
  SUPPORT_CONFIG.genericPaymentLink ||
  SUPPORT_CONFIG.amounts.some((item) => item.link)
);

export { SUPPORT_CONFIG, isSupportConfigured };
